"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_TYPE = exports.DEFAULT_STYLE = exports.DEFAULT_DATA = exports.BREAKPOINTS = void 0;
var ICON_TYPE = 'CloseIcon';
exports.ICON_TYPE = ICON_TYPE;
var DEFAULT_STYLE = {
  SUB: 'sub',
  SMALL: 'small',
  TITLE_NORMAL: 'titleNormal',
  LINK_COLOR: 'secondary',
  TEXT_COLOR: 'greyDarker',
  ICON_COLOR: 'greyDark'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var BREAKPOINTS = {
  MOBILE: '599px',
  SMALL_TABLET: '600px',
  MEDIUM_TABLET: '720px',
  LARGE_TABLET: '840px',
  DESKTOP: '1280px'
};
exports.BREAKPOINTS = BREAKPOINTS;
var DEFAULT_DATA = {
  content: // eslint-disable-next-line max-len
  'We use cookies to give you a better experience on AirAsia.com. By continuing to use our website, you are agreeing to the use of cookies as set out in our {0} Privacy Statement {0}.',
  link: 'https://www.airasia.com/my/en/about-us/privacy-policy.page'
};
exports.DEFAULT_DATA = DEFAULT_DATA;